import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import api from '../api/index.ts';
import endpoints from '../endpoints.ts';

const useSearch = (filters, options) => {
  const { ...queryOptions } = options;
  return useQuery({
    queryKey: [endpoints.documentException.read.many.by.filters(), filters],
    queryFn: async () => {
      return await api.documentException.read.many.by.filters(filters);
    },
    ...queryOptions,
  });
};

const useGetDocumentExceptionErrors = options => {
  const { documentExceptionId, ...queryOptions } = options;
  return useQuery({
    queryKey: [
      endpoints.documentException.read.one.by.id(),
      documentExceptionId,
    ],
    queryFn: async () => {
      return await api.documentException.read.one.by.id({
        documentExceptionId,
      });
    },
    ...queryOptions,
  });
};

const useGetDocumentExceptionErrorsCount = (
  options?: Partial<UseQueryOptions<number | string, Error>>
): UseQueryResult<number | string, Error> => {
  const { ...queryOptions } = options ?? {};

  return useQuery({
    queryKey: [endpoints.documentException.read.count()],
    queryFn: async () => (await api.documentException.read.count()) || 0,
    ...queryOptions,
  });
};

const queryHooks = {
  useSearch,
  useGetDocumentExceptionErrors,
  useGetDocumentExceptionErrorsCount,
};

export default queryHooks;
